<template>
    <div v-if="value !== null" class="vote-display">
            <b-icon icon="star" size="is-small" class="has-text-warning star-outline"></b-icon>
        <span class="vote-text">{{ value.toFixed(1) }}/10</span>
    </div>
</template>

<script>
export default {
  name: 'BrewVoteDisplay',
  props: {
    value: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped>
    .vote-display {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-left: 8px;
        flex-shrink: 0;
        margin-right: 8px;
    }

    .vote-text {
        font-size: 0.9rem;
        white-space: nowrap;
        font-weight: bold;
    }

    .star-outline {
        -webkit-text-stroke: 1px #696969;
        transform: translateY(-1px);
    }
</style>